// extracted by mini-css-extract-plugin
export default {"field":"PolicyTextInput_field__iHuvX","label":"PolicyTextInput_label__Vt6cL"};